import React, { ReactNode, useEffect } from "react";
import useClipboard from "react-use-clipboard";

import { Button, ButtonIconGutter } from "../button/Button";

export interface CopyToClipBoardProps {
  copyText: string;
  icon?: React.ReactNode;
  className?: string;
  childClassName?: string;
  children?: ReactNode;
  iconColor?: boolean;
  onClick(): void;
}

export const CopyToClipboard: React.FC<CopyToClipBoardProps> = ({
  copyText,
  icon,
  onClick,
  className,
  childClassName,
  children,
  iconColor = false,
}) => {
  const [isCopied, setCopied] = useClipboard(copyText, { successDuration: 1000 });

  // trigger callback if text is copied to clipboard
  useEffect(() => {
    if (isCopied) {
      onClick();
    }
  }, [isCopied, onClick]);

  if (icon) {
    return (
      <Button
        iconColor={iconColor}
        kind="TEXT"
        height="AUTO"
        iconRight={icon}
        iconGutter={ButtonIconGutter.SMALL}
        onClick={setCopied}
        className={className}
      >
        <span className={childClassName}>{children}</span>
      </Button>
    );
  }

  return (
    <Button kind="TEXT" height="AUTO" className={className} onClick={setCopied}>
      {children}
    </Button>
  );
};
